export default __webpack_public_path__ + "static/media/bg4.f1379f01.webp";